import { render, staticRenderFns } from "./NewZgbTeamMembersList.vue?vue&type=template&id=b2e6a568"
import script from "./NewZgbTeamMembersList.vue?vue&type=script&lang=js"
export * from "./NewZgbTeamMembersList.vue?vue&type=script&lang=js"
import style0 from "./NewZgbTeamMembersList.vue?vue&type=style&index=0&id=b2e6a568&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports